import React, { useEffect, useState } from 'react'
import { toast, ToastContainer } from 'react-toastify';
import ReactTooltip from 'react-tooltip';
import { Col, Container, Row } from 'reactstrap';
import { getFundByAmc } from '../../stores/services/funds.service';
import { useSelector } from 'react-redux';
import Select from "react-select";
import moment from 'moment';
import { getAllDividendAnnouncements, getDividendDisbursementsByAnnouncementId } from '../../stores/services/dividend-announcement.service';
import { getAllUnitHoldersByAmc } from '../../stores/services/unit-holder.service';
import ReportTemplates from '../../components/ReportTemplate/ReportTemplate';
import { exportToTxt, generateDividendLedgerEntries, generateExcel, numberWithCommas } from '../../utils/customFunction';
import html2pdf from "html2pdf.js";
import DividendCard from './AnnouncementListing';
import DividendTable from './DividendTable';
import { BsTable } from "react-icons/bs";
import ReportHeader from '../reports/report-header';


function ProcessEntitlementsReport() {
    const contentRef = React.useRef(null);
    const pdfExportComponent = React.useRef<any>(null);
    let date = new Date();

    const ColumnHeading = [
        {
            label: "Sr",
            value: "Sr",
        },
        {
            label: "Holding",
            value: "Holding",
        },
        {
            label: "Gross Dividend",
            value: "Gross Dividend",
        },
        {
            label: "ROC Rate",
            value: "ROC Rate",
        },
        {
            label: "ROC Amount",
            value: "ROC Amount",
        },
        {
            label: "ROC Units",
            value: "ROC Units",
        },
        {
            label: "Taxable Dividend",
            value: "Taxable Dividend",
        },
        {
            label: "Tax Amount",
            value: "Tax Amount",
        },
        {
            label: "Net Dividend",
            value: "Net Dividend",
        },
        {
            label: "Encash",
            value: "Encash",
        },
        {
            label: "Reinv Units",
            value: "Reinv Units",
        },
    ];

    const fixedOrder = [
        "Sr",
        "Holding",
        "Gross Dividend",
        "ROC Rate",
        "ROC Amount",
        "ROC Units",
        "Taxable Dividend",
        "Tax Amount",
        "Net Dividend",
        "Encash",
        "Reinv Units",
    ];

    const [ColumnArr, setColumnArr] = useState(ColumnHeading);
    const [selectedValues, setSelectedValues] = useState<any>({
        heading: "",
        sub_heading: "",
        columns: ColumnHeading?.map?.((col) => col?.value),
        balance: [],
    });
    const [isSearchTrue, setIsSearchTrue] = useState(false);
    const [fontSizeVal, setFontSizeVal] = useState<any>(18);
    const [paperSizeVal, setPaperSizeVal] = useState("A4");
    const [layoutVal, setLayoutVal] = useState("Landscape");
    const [marginPDF, setMarginPDF] = useState("1cm");
    const [scalePDF, setScalePDF] = useState(0.5);
    const [screenSizePerPdf, setScreenSizePerPdf] = useState();
    const [dimensionOfPages, setDimensionOfPages] = useState<any>();
    const [itemsPerPage, setItemsPerPage] = useState<any>(10);
    const [itemsToShow, setItemsToShow] = useState(10);
    const [loader, setLoader] = useState(false);

    const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);
    const [fundData, setFundData] = useState<any>([]);
    const [selectedFund, setSelectedFund] = useState("");
    const [fundDataLoading, setFundDataLoading] = useState(false);
    const [announcementDataLoading, setAnnouncementDataLoading] = useState(false);
    const [announcementData, setAnnouncementData] = useState<any>([]);
    const [apiCallDone, setApiCallDone] = useState(false);
    const [selectedAnnoucement, setSelectedAnnoucement] = useState("");
    const [dividendData, setDividendData] = useState<any>([]);
    const [allFolios, setAllFolios] = useState<any>([]);
    const [hasNextPage, setHasNextPage] = useState(false);
    const [folio, setFolio] = useState<any>("");
    const [btnLoading, setBtnLoading] = useState(false);
    const email = sessionStorage.getItem("email") || "";
    const [dividendSummaryData, setDividendSummaryData] = useState<any>()
    const [fund_code, setFund_code] = useState(
        JSON.parse(sessionStorage.getItem("fund_code") || "[]")
    );
    const amc_code = sessionStorage.getItem("amc_code") || "";
    const [apiLoading, setApiLoading] = useState(false);

    const dividendSummary = {
        totalGrossDividend: 0,
        totalNetDividend: 0,
        totalRefundOfCapital: 0,
        totalROCUnits: 0,
        totalReinvestAmount: 0,
        totalReinvestUnits: 0,
        totalTaxAmount: 0,
        totalDividendEncashment: 0,
    };

    const getAnnoucement = async () => {
        try {
            setAnnouncementDataLoading(true);
            let res = await getAllDividendAnnouncements(email, amc_code, "");
            if (res.data.status == 200 && res?.data?.data?.length > 0) {
                setAnnouncementData(res.data.data);
                setAnnouncementDataLoading(false);
            } else {
                setAnnouncementData([]);
                setAnnouncementDataLoading(false);
            }
        } catch (error) {
            setAnnouncementData([]);
            setAnnouncementDataLoading(false);
        }
    };

    const getAllFolios = async () => {
        try {
            const response = await getAllUnitHoldersByAmc(email, amc_code);
            if (response.data.status == 200) {
                setAllFolios(response.data.data);
            }
        } catch (error) { }
    };

    useEffect(() => {
        const fetchData = async () => {
            setApiLoading(true);
            try {
                await Promise.all([
                    getAnnoucement(),
                    getAllFolios()
                ]);
            } catch (error) {
                toast.error("Error during initial data fetch");
            } finally {
                setApiLoading(false);
            }
        };

        fetchData();


    }, []);

    useEffect(() => {
        const elements = document.querySelectorAll(
            "#test"
        ) as NodeListOf<HTMLElement>;
        elements.forEach((element) => {
            element.style.setProperty("font-size", `${fontSizeVal}px`, "important");
        });
    }, [fontSizeVal, itemsToShow, selectedValues, isSearchTrue]);

    const renderAnnoucementDropdown = () => {
        return announcementData?.map((item: any, index: string) => {
            return {
                value: item?.announcement_id,
                label: `${moment(item?.to_date)?.format("DD-MMM-YYYY")} - ${item?.description?.length > 30 ? item?.description?.slice(0, 30) + "..." : item?.description}`,
            };
        });
    };

    const renderAllFoliosDropdown = () => {
        return allFolios.map((item: any, index: number) => {
            return {
                label: `${item?.folio_no?.replace("UNITHOLDER_", "")} - (${item?.name})`,
                value: item?.folio_no?.replace("UNITHOLDER_", ""),
            };
        });
    };

    const handleShowMore = () => {
        setItemsToShow((prev) => prev + itemsPerPage);
    };

    const selectedFolioVal = React.useMemo(() => {
        const selected = allFolios?.find(
            (item) => item?.folio_no?.replace("UNITHOLDER_", "") === folio
        );
        return selected
            ? {
                value: selected?.folio_no?.replace("UNITHOLDER_", ""),
                label: `${selected?.folio_no?.replace("UNITHOLDER_", "")} - (${selected?.name})`,
            }
            : null;
    }, [allFolios, folio]);

    const selectedAnnouncementVal = React.useMemo(() => {
        const selected = announcementData.find(
            (item) => item?.announcement_id === selectedAnnoucement
        );
        return selected
            ? {
                value: selected?.announcement_id,
                finalized: selected?.entitlements_finalized,
                paid: selected?.paid,
                label: `${moment(selected?.to_date)?.format("DD-MMM-YYYY")} - ${selected?.description}`,
            }
            : null;
    }, [announcementData, selectedAnnoucement]);

    const formatDate = (dateString?: string) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
        });
    };

    const handleDownloadSampleFile = () => {

        const totalNewUnits: any = +dividendSummaryData?.ledgerTotalRefundUnits + +dividendSummaryData?.ledgerTotalReinvestUnits
        const selectedUnitholderDetails = allFolios?.find(
            (item) => item?.folio_no?.replace("UNITHOLDER_", "") === folio
        )
        const headings = [
            [`Dividend - ${dividendSummaryData?.description}`],
            ["Fund", "ID", "Rate Per Unit", "Dividend Period", "Closing NAV", "Ex-NAV", "Opening Ex-NAV"],
            [
                `${dividendSummaryData?.fund_code}`,
                `${numberWithCommas(parseFloat(dividendSummaryData?.dividend_per_unit || 0)?.toFixed(2))}`,
                `${formatDate(dividendSummaryData?.from_date)} - ${formatDate(dividendSummaryData?.to_date)}`,
                `${numberWithCommas(parseFloat(dividendSummaryData?.closing_nav_before_dist || 0)?.toFixed(2))}`,
                `${numberWithCommas(parseFloat(dividendSummaryData?.ex_nav_after_dist || 0)?.toFixed(2))}`,
                `${numberWithCommas(parseFloat(dividendSummaryData?.opening_ex_nav || 0)?.toFixed(2))}`,
            ],
            [""],
            [`Dividend Totals`],
            ["Gross Dividend", "Net Dividend", "Refund of Capital", "ROC Units", "Reinvest Amount", "Reinvest Units", "Tax Amount", "Total New Units", "Dividend Encashment"],
            [
                `${numberWithCommas(parseFloat(dividendSummaryData?.ledgerTotalGrossDividend || 0)?.toFixed(2))}`,
                `${numberWithCommas(parseFloat(dividendSummaryData?.ledgerTotalNetDividend || 0)?.toFixed(2))}`,
                `${numberWithCommas(parseFloat(dividendSummaryData?.ledgerTotalRefundCapital || 0)?.toFixed(2))}`,
                `${numberWithCommas(parseFloat(dividendSummaryData?.ledgerTotalRefundUnits || 0)?.toFixed(4))}`,
                `${numberWithCommas(parseFloat(dividendSummaryData?.ledgerTotalReinvestAmount || 0)?.toFixed(2))}`,
                `${numberWithCommas(parseFloat(dividendSummaryData?.ledgerTotalReinvestUnits || 0)?.toFixed(4))}`,
                `${numberWithCommas(parseFloat(dividendSummaryData?.ledgerTotalTaxAmount || 0)?.toFixed(2))}`,
                `${numberWithCommas(parseFloat(totalNewUnits || 0)?.toFixed(4))}`,
                `${numberWithCommas(parseFloat(dividendSummaryData?.ledgerTotalEncashmentAmount || 0)?.toFixed(2))}`,
            ],
            ["Unitholder"],
            ["Name", "Account No", "Bank/Branch", "Account Title", "Tax Status", "Reinvest", "Zakat Exempt", "ID"],
            [
                `${selectedUnitholderDetails?.name}`,
                `${selectedUnitholderDetails?.account_no}`,
                `${selectedUnitholderDetails?.bank_name}-${selectedUnitholderDetails?.branch_name}`,
                `${selectedUnitholderDetails?.account_title}`,
                `${selectedUnitholderDetails?.tax_status}`,
                `${selectedUnitholderDetails?.reinvest == true ? "Yes" : "No"}`,
                `${selectedUnitholderDetails?.zakat_exempt == true ? "Yes" : "No"}`,
                `${selectedUnitholderDetails?.folio_no?.replace("DL-", "")}`,
            ],
        ];

        const dataSequence = dividendData
            ?.map((ele, index) => {
                return {
                    Sr: index + 1,
                    holding: `${numberWithCommas(parseFloat(ele?.unitholder_holding_for_dividend || 0).toFixed(4))}`,
                    gross_amount: numberWithCommas(parseFloat(ele?.gross_dividend || 0).toFixed(2)),
                    roc_rate: numberWithCommas(parseFloat(ele?.refund_purchase_nav || 0).toFixed(2)),
                    roc_amount: numberWithCommas(parseFloat(ele?.refund_of_capital || 0).toFixed(2)),
                    roc_units: `${ele?.refund_of_capital > 0
                        ? numberWithCommas(
                            parseFloat(ele?.reinvestment_units || 0)?.toFixed(4)
                        )
                        : numberWithCommas(
                            parseFloat(ele?.refund_of_capital_units || 0)?.toFixed(4)
                        )}`,
                    taxable_dividend: numberWithCommas(parseFloat(ele?.taxable_dividend || 0).toFixed(2)),
                    tax_amount: numberWithCommas(parseFloat(ele?.tax_amount || 0).toFixed(2)),
                    net_dividend: numberWithCommas(parseFloat(ele?.net_dividend || 0).toFixed(2)),
                    encash: numberWithCommas(parseFloat(ele?.encashment_amount || 0).toFixed(2)),
                    reinv_units: `${ele?.refund_of_capital > 0
                        ? numberWithCommas(
                            parseFloat(ele?.reinvestment_units || 0)?.toFixed(4)
                        )
                        : numberWithCommas(
                            parseFloat(ele?.reinvestment_units || 0)?.toFixed(4)
                        )}`,
                };
            });

        const reorderColumns = (columns, order) => {
            return order.filter((column) => columns.includes(column));
        };

        const reorderedColumns = reorderColumns(
            selectedValues?.columns,
            fixedOrder
        );

        const ArrayData =
            selectedValues?.columns?.length > 0 &&
            dataSequence?.map((entry) => {
                const result = {};
                reorderedColumns.forEach((column) => {
                    if (column === "Sr") {
                        result[column] = entry?.Sr;
                    } else if (column === "Holding") {
                        result[column] = entry?.holding;
                    } else if (column === "Gross Dividend") {
                        result[column] = entry?.gross_amount;
                    }
                    else if (column === "ROC Rate") {
                        result[column] = entry?.roc_rate;
                    }
                    else if (column === "ROC Amount") {
                        result[column] = entry?.roc_amount;
                    } else if (column === "ROC Units") {
                        result[column] = entry?.roc_units;
                    } else if (column === "Taxable Dividend") {
                        result[column] = entry?.taxable_dividend;
                    } else if (column === "Tax Amount") {
                        result[column] = entry?.tax_amount;
                    }
                    else if (column === "Net Dividend") {
                        result[column] = entry?.net_dividend;
                    }
                    else if (column === "Encash") {
                        result[column] = entry?.encash;
                    }
                    else if (column === "Reinv Units") {
                        result[column] = entry?.reinv_units;
                    }
                });
                return result;
            });

        generateExcel(
            "Dividend Statement ",
            "Dividend Statement",
            "File",
            "File",
            "DCCL",
            headings,
            reorderedColumns,
            ArrayData,
            [],
            []
        );

    };

    const searchData = async (isFlag: string = "", pageNoVal: string = "") => {
        setIsSearchTrue(false)
        setBtnLoading(true)
        try {
            let announcementDetails = announcementData.find(
                (item) => item.announcement_id === selectedAnnoucement
            );

            let res = await getDividendDisbursementsByAnnouncementId(
                email,
                amc_code,
                "",
                announcementDetails?.announcement_id || "",
                announcementDetails?.announcement_number || "",
                "",
                "",
                "",
                pageNoVal || "",
                "",
                folio
            );

            setApiCallDone(true);
            if (res.data.status === 200 && res.data.data?.length > 0) {
                const tempData = isFlag == ""
                    ? [...res?.data?.data]
                    : [...dividendData, ...res?.data?.data]



                // if (tempData?.filter((ele) => ele?.folio_no === folio)?.length == 0) {
                //     toast.error("No data found for this Folio")
                // }

                // tempData?.filter((ele) => ele?.folio_no === folio)?.map((ele) => {
                tempData?.map((ele) => {
                    dividendSummary.totalGrossDividend += ele?.gross_dividend || 0;
                    dividendSummary.totalNetDividend += ele?.net_dividend;
                    dividendSummary.totalRefundOfCapital += ele?.refund_of_capital;
                    dividendSummary.totalROCUnits +=
                        ele?.refund_of_capital > 0
                            ? (ele?.reinvestment_units || 0)
                            : (ele?.refund_of_capital_units || 0)
                        ;
                    dividendSummary.totalReinvestAmount += ele?.reinvest === true ? ele?.net_dividend : 0;
                    dividendSummary.totalReinvestUnits +=
                        ele?.refund_of_capital > 0
                            ? ele?.reinvestment_units || 0 :
                            ele?.reinvestment_units || 0

                        ;
                    dividendSummary.totalTaxAmount += ele?.tax_amount || 0;
                    dividendSummary.totalDividendEncashment += ele?.encashment_amount || 0;
                })

                setDividendSummaryData(
                    {
                        ...announcementDetails,
                        ledgerTotalEncashmentAmount: dividendSummary.totalDividendEncashment,
                        ledgerTotalGrossDividend: dividendSummary.totalGrossDividend,
                        ledgerTotalNetDividend: dividendSummary.totalNetDividend,
                        ledgerTotalRefundCapital: dividendSummary.totalRefundOfCapital,
                        ledgerTotalRefundUnits: dividendSummary.totalROCUnits,
                        ledgerTotalReinvestAmount: dividendSummary.totalReinvestAmount,
                        ledgerTotalReinvestUnits: dividendSummary.totalReinvestUnits,
                        ledgerTotalTaxAmount: dividendSummary.totalTaxAmount,

                    }
                )

                setDividendData(
                    // tempData?.filter((ele) => ele?.folio_no === folio)
                    tempData
                )
                setHasNextPage(res?.data?.page_info?.hasNextPage || false);
                setIsSearchTrue(true)
            } else {
                setIsSearchTrue(false)
                setHasNextPage(false);
                setDividendData([]);
                toast.error(res?.data?.message || res?.message);
            }
            setBtnLoading(false);
        } catch (error) {
            setIsSearchTrue(false)
            setHasNextPage(false);
            setBtnLoading(false);
            setDividendData([]);
            toast.error("No data found!");
        }
    };

    const handleTXT = () => {
        const totalNewUnits: any = +dividendSummaryData?.ledgerTotalRefundUnits + +dividendSummaryData?.ledgerTotalReinvestUnits
        const selectedUnitholderDetails = allFolios?.find(
            (item) => item?.folio_no?.replace("UNITHOLDER_", "") === folio
        )
        const headings = [
            [`Dividend - ${dividendSummaryData?.description}`],
            ["Fund", "ID", "Rate Per Unit", "Dividend Period", "Closing NAV", "Ex-NAV", "Opening Ex-NAV"],
            [
                `${dividendSummaryData?.fund_code}`,
                `${numberWithCommas(parseFloat(dividendSummaryData?.dividend_per_unit || 0)?.toFixed(2))}`,
                `${formatDate(dividendSummaryData?.from_date)} - ${formatDate(dividendSummaryData?.to_date)}`,
                `${numberWithCommas(parseFloat(dividendSummaryData?.closing_nav_before_dist || 0)?.toFixed(2))}`,
                `${numberWithCommas(parseFloat(dividendSummaryData?.ex_nav_after_dist || 0)?.toFixed(2))}`,
                `${numberWithCommas(parseFloat(dividendSummaryData?.opening_ex_nav || 0)?.toFixed(2))}`,
            ],
            [""],
            [`Dividend Totals`],
            ["Gross Dividend", "Net Dividend", "Refund of Capital", "ROC Units", "Reinvest Amount", "Reinvest Units", "Tax Amount", "Total New Units", "Dividend Encashment"],
            [
                `${numberWithCommas(parseFloat(dividendSummaryData?.ledgerTotalGrossDividend || 0)?.toFixed(2))}`,
                `${numberWithCommas(parseFloat(dividendSummaryData?.ledgerTotalNetDividend || 0)?.toFixed(2))}`,
                `${numberWithCommas(parseFloat(dividendSummaryData?.ledgerTotalRefundCapital || 0)?.toFixed(2))}`,
                `${numberWithCommas(parseFloat(dividendSummaryData?.ledgerTotalRefundUnits || 0)?.toFixed(4))}`,
                `${numberWithCommas(parseFloat(dividendSummaryData?.ledgerTotalReinvestAmount || 0)?.toFixed(2))}`,
                `${numberWithCommas(parseFloat(dividendSummaryData?.ledgerTotalReinvestUnits || 0)?.toFixed(4))}`,
                `${numberWithCommas(parseFloat(dividendSummaryData?.ledgerTotalTaxAmount || 0)?.toFixed(2))}`,
                `${numberWithCommas(parseFloat(totalNewUnits || 0)?.toFixed(4))}`,
                `${numberWithCommas(parseFloat(dividendSummaryData?.ledgerTotalEncashmentAmount || 0)?.toFixed(2))}`,
            ],
            ["Unitholder"],
            ["Name", "Account No", "Bank/Branch", "Account Title", "Tax Status", "Reinvest", "Zakat Exempt", "ID"],
            [
                `${selectedUnitholderDetails?.name}`,
                `${selectedUnitholderDetails?.account_no}`,
                `${selectedUnitholderDetails?.bank_name}-${selectedUnitholderDetails?.branch_name}`,
                `${selectedUnitholderDetails?.account_title}`,
                `${selectedUnitholderDetails?.tax_status}`,
                `${selectedUnitholderDetails?.reinvest == true ? "Yes" : "No"}`,
                `${selectedUnitholderDetails?.zakat_exempt == true ? "Yes" : "No"}`,
                `${selectedUnitholderDetails?.folio_no?.replace("DL-", "")}`,
            ],
        ];

        const dataSequence = dividendData
            ?.map((ele, index) => {
                return {
                    Sr: index + 1,
                    holding: `${numberWithCommas(parseFloat(ele?.unitholder_holding_for_dividend || 0).toFixed(4))}`,
                    gross_amount: numberWithCommas(parseFloat(ele?.gross_dividend || 0).toFixed(2)),
                    roc_rate: numberWithCommas(parseFloat(ele?.refund_purchase_nav || 0).toFixed(2)),
                    roc_amount: numberWithCommas(parseFloat(ele?.refund_of_capital || 0).toFixed(2)),
                    roc_units: `${ele?.refund_of_capital > 0
                        ? numberWithCommas(
                            parseFloat(ele?.reinvestment_units || 0)?.toFixed(4)
                        )
                        : numberWithCommas(
                            parseFloat(ele?.refund_of_capital_units || 0)?.toFixed(4)
                        )}`,
                    taxable_dividend: numberWithCommas(parseFloat(ele?.taxable_dividend || 0).toFixed(2)),
                    tax_amount: numberWithCommas(parseFloat(ele?.tax_amount || 0).toFixed(2)),
                    net_dividend: numberWithCommas(parseFloat(ele?.net_dividend || 0).toFixed(2)),
                    encash: numberWithCommas(parseFloat(ele?.encashment_amount || 0).toFixed(2)),
                    reinv_units: `${ele?.refund_of_capital > 0
                        ? numberWithCommas(
                            parseFloat(ele?.reinvestment_units || 0)?.toFixed(4)
                        )
                        : numberWithCommas(
                            parseFloat(ele?.reinvestment_units || 0)?.toFixed(4)
                        )}`,
                };
            });

        const reorderColumns = (columns, order) => {
            return order.filter((column) => columns.includes(column));
        };

        const reorderedColumns = reorderColumns(
            selectedValues?.columns,
            fixedOrder
        );

        const ArrayData =
            selectedValues?.columns?.length > 0 &&
            dataSequence?.map((entry) => {
                const result = {};
                reorderedColumns.forEach((column) => {
                    if (column === "Sr") {
                        result[column] = entry?.Sr;
                    } else if (column === "Holding") {
                        result[column] = entry?.holding;
                    } else if (column === "Gross Dividend") {
                        result[column] = entry?.gross_amount;
                    }
                    else if (column === "ROC Rate") {
                        result[column] = entry?.roc_rate;
                    }
                    else if (column === "ROC Amount") {
                        result[column] = entry?.roc_amount;
                    } else if (column === "ROC Units") {
                        result[column] = entry?.roc_units;
                    } else if (column === "Taxable Dividend") {
                        result[column] = entry?.taxable_dividend;
                    } else if (column === "Tax Amount") {
                        result[column] = entry?.tax_amount;
                    }
                    else if (column === "Net Dividend") {
                        result[column] = entry?.net_dividend;
                    }
                    else if (column === "Encash") {
                        result[column] = entry?.encash;
                    }
                    else if (column === "Reinv Units") {
                        result[column] = entry?.reinv_units;
                    }
                });
                return result;
            });

        let formattedContent = '';

        formattedContent += `"Dividend - ${dividendSummaryData?.description}"\n`;

        formattedContent += `"Fund","ID","Rate Per Unit","Dividend Period","Closing NAV","Ex-NAV","Opening Ex-NAV"\n`;

        formattedContent += `"${dividendSummaryData?.fund_code}","${numberWithCommas(parseFloat(dividendSummaryData?.dividend_per_unit || 0)?.toFixed(2))}","${formatDate(dividendSummaryData?.from_date)} - ${formatDate(dividendSummaryData?.to_date)}","${numberWithCommas(parseFloat(dividendSummaryData?.closing_nav_before_dist || 0)?.toFixed(2))}","${numberWithCommas(parseFloat(dividendSummaryData?.ex_nav_after_dist || 0)?.toFixed(2))}","${numberWithCommas(parseFloat(dividendSummaryData?.opening_ex_nav || 0)?.toFixed(2))}"\n`;

        formattedContent += `\n`;

        formattedContent += `"Dividend Totals"\n`;

        formattedContent += `"Gross Dividend","Net Dividend","Refund of Capital","ROC Units","Reinvest Amount","Reinvest Units","Tax Amount","Total New Units","Dividend Encashment"\n`;

        formattedContent += `"${numberWithCommas(parseFloat(dividendSummaryData?.ledgerTotalGrossDividend || 0)?.toFixed(2))}","${numberWithCommas(parseFloat(dividendSummaryData?.ledgerTotalNetDividend || 0)?.toFixed(2))}","${numberWithCommas(parseFloat(dividendSummaryData?.ledgerTotalRefundCapital || 0)?.toFixed(2))}","${numberWithCommas(parseFloat(dividendSummaryData?.ledgerTotalRefundUnits || 0)?.toFixed(4))}","${numberWithCommas(parseFloat(dividendSummaryData?.ledgerTotalReinvestAmount || 0)?.toFixed(2))}","${numberWithCommas(parseFloat(dividendSummaryData?.ledgerTotalReinvestUnits || 0)?.toFixed(4))}","${numberWithCommas(parseFloat(dividendSummaryData?.ledgerTotalTaxAmount || 0)?.toFixed(2))}","${numberWithCommas(parseFloat(totalNewUnits || 0)?.toFixed(4))}","${numberWithCommas(parseFloat(dividendSummaryData?.ledgerTotalEncashmentAmount || 0)?.toFixed(2))}"\n`;

        formattedContent += `"Unitholder"\n`;

        formattedContent += `"Name","Account No","Bank/Branch","Account Title","Tax Status","Reinvest","Zakat Exempt","ID"\n`;

        formattedContent += `"${selectedUnitholderDetails?.name}","${selectedUnitholderDetails?.account_no}","${selectedUnitholderDetails?.bank_name}-${selectedUnitholderDetails?.branch_name}","${selectedUnitholderDetails?.account_title}","${selectedUnitholderDetails?.tax_status}","${selectedUnitholderDetails?.reinvest == true ? "Yes" : "No"}","${selectedUnitholderDetails?.zakat_exempt == true ? "Yes" : "No"}","${selectedUnitholderDetails?.folio_no?.replace("DL-", "")}"\n`;
        exportToTxt(
            formattedContent,
            selectedValues,
            ArrayData,
            "Dividend Statement"
        );

    };

    const handleGeneratePdf = () => {
        const element = contentRef.current;
        let fileName = "Unit-Holder-Statement.pdf";
        const options = {
            filename: fileName,
            margin: [10, 3, 10, 3],
            image: { type: "jpeg", quality: 0.95 },
            html2canvas: { scale: 1 },
            jsPDF: {
                unit: "mm",
                format: paperSizeVal || "A4",
                orientation: layoutVal === "Landscape" ? "landscape" : "portrait",
            },
            pagebreak: { mode: ["avoid-all", "css", "legacy"] },
        };
        html2pdf().from(element).set(options).save();
    };

    //  const handleDownloadSampleFile = () => {
    //     const headings = [
    //       [selectedValues?.heading ? selectedValues?.heading : "", "", "", ""],
    //       [
    //         selectedValues?.sub_heading ? selectedValues?.sub_heading : "",
    //         "",
    //         "",
    //         "",
    //       ],
    //       ["Name", `${unitHolderData[0].name}`, "Unit Holder", `${resFolioNo}`],
    //       [
    //         "From Date",
    //         `${moment(resFromDate).format("DD-MM-YYYY")}`,
    //         "Report Date",
    //         `${moment(date).format("DD-MM-YYYY")}`,
    //       ],
    //       ["To Date", `${moment(resToDate).format("DD-MM-YYYY")}`],
    //       [
    //         "Account Title",
    //         `${unitHolderData[0].account_title}`,
    //         "Account No",
    //         `${unitHolderData[0].account_no}`,
    //       ],
    //       [
    //         "Bank",
    //         `${unitHolderData[0].bank_name}`,
    //         "Branch",
    //         `${unitHolderData[0].branch_name}`,
    //       ],
    //     ];
    //     let nav;
    //     let balance;

    //     unitHolderStatement?.slice(0, itemsToShow).map((unitHolder: any) => {
    //       nav =
    //         dailyNav?.find((item) => item.fund == unitHolder.fund_code)?.nav > 0 &&
    //           selectedValues?.columns?.includes("NAV")
    //           ? `NAV: ${numberWithCommas(
    //             (
    //               dailyNav?.find((item) => item.fund == unitHolder.fund_code)
    //                 ?.nav || 0
    //             )?.toFixed(4)
    //           )}`
    //           : "";
    //       balance =
    //         dailyNav?.find((item) => item.fund == unitHolder.fund_code)?.nav > 0
    //           ? `Closing Balance: ${numberWithCommas(
    //             (
    //               +unitHolder.closingUnits *
    //               (dailyNav?.find((item) => item.fund == unitHolder.fund_code)
    //                 ?.nav || 0)
    //             )?.toFixed(4)
    //           )}`
    //           : "";
    //     });

    //     const dataSequence = unitHolderStatement
    //       ?.slice(0, itemsToShow)
    //       ?.map((ele) => {
    //         let temp = ele?.forPeriodTxns?.map((ele1) => {
    //           return {
    //             Date: moment(ele1?.settlement_date).format("DD-MM-YYYY"),
    //             TXN_ID: ele1?.txn_id,
    //             Description:
    //               CapTxnType(ele1?.txnr_type) !== "Transfer of Units"
    //                 ? CapTxnType(ele1?.txnr_type)
    //                 : ele1?.broker === "receiver"
    //                   ? CapTxnType(ele1?.txnr_type) + `(receiver)`
    //                   : CapTxnType(ele1?.txnr_type) + `(sender)`,
    //             Capital_Refund_Units:
    //               numberWithCommas(
    //                 parseFloat(ele1?.refund_of_capital || "0").toFixed(4)
    //               ) || "0.00",
    //             Fund_Units: numberWithCommas(
    //               parseFloat(ele1?.units).toFixed(4)
    //             ),
    //             NAV: parseFloat(ele1?.nav || 0).toFixed(4),
    //             Gross_Amount: numberWithCommas(
    //               parseFloat(ele1?.gross_amount).toFixed(4)
    //             ),
    //             Sale_Load:
    //               numberWithCommas(
    //                 parseFloat(ele1?.sale_load).toFixed(4) === undefined
    //                   ? "0.00"
    //                   : parseFloat(ele1?.sale_load).toFixed(4)
    //               ) || "0.00",
    //             Redemption_Load:
    //               numberWithCommas(
    //                 parseFloat(ele1?.redemption_load).toFixed(4) === undefined
    //                   ? "0.00"
    //                   : parseFloat(ele1?.redemption_load).toFixed(4)
    //               ) || "0.00",
    //             CGT:
    //               numberWithCommas(
    //                 parseFloat(ele1?.tax_cgt).toFixed(4) === undefined
    //                   ? "0.00"
    //                   : parseFloat(ele1?.tax_cgt).toFixed(4)
    //               ) || "0.00",
    //             Net_Amount: numberWithCommas(
    //               parseFloat(ele1?.net_amount).toFixed(4)
    //             ),
    //             Closing_Units: numberWithCommas(
    //               parseFloat(ele1?.closingUnits).toFixed(4) === undefined
    //                 ? "0.00"
    //                 : parseFloat(ele1?.closingUnits).toFixed(4)
    //             ),
    //           };
    //         });

    //         let heading = ele?.fund_name ?
    //           `${ele?.fund_name} (${ele.fund_code})` :
    //           ele?.fund_code

    //         temp?.unshift({
    //           Date: selectedValues?.columns?.includes("Date")
    //             ? `${heading}_change${ele?.opening_balance}`
    //             : "",
    //           TXN_ID:
    //             !selectedValues?.columns?.includes("Date") &&
    //               selectedValues?.columns?.includes("TXN ID")
    //               ? `${heading}_change${ele?.opening_balance}`
    //               : "",
    //           Description:
    //             !selectedValues?.columns?.includes("Date") &&
    //               !selectedValues?.columns?.includes("TXN ID") &&
    //               selectedValues?.columns?.includes("Description")
    //               ? `${heading}_change${ele?.opening_balance}`
    //               : "",
    //           Capital_Refund_Units:
    //             !selectedValues?.columns?.includes("Date") &&
    //               !selectedValues?.columns?.includes("TXN ID") &&
    //               !selectedValues?.columns?.includes("Description") &&
    //               selectedValues?.columns?.includes("Capital Refund Units")
    //               ? `${heading}_change${ele?.opening_balance}`
    //               : "",
    //           Fund_Units:
    //             !selectedValues?.columns?.includes("Date") &&
    //               !selectedValues?.columns?.includes("TXN ID") &&
    //               !selectedValues?.columns?.includes("Description") &&
    //               !selectedValues?.columns?.includes("Capital Refund Units") &&
    //               selectedValues?.columns?.includes("Fund Units")
    //               ? `${heading}_change${ele?.opening_balance}`
    //               : "",
    //           NAV:
    //             !selectedValues?.columns?.includes("Date") &&
    //               !selectedValues?.columns?.includes("TXN ID") &&
    //               !selectedValues?.columns?.includes("Description") &&
    //               !selectedValues?.columns?.includes("Capital Refund Units") &&
    //               !selectedValues?.columns?.includes("Fund Units") &&
    //               selectedValues?.columns?.includes("NAV")
    //               ? `${heading}_change${ele?.opening_balance}`
    //               : "",
    //           Gross_Amount:
    //             !selectedValues?.columns?.includes("Date") &&
    //               !selectedValues?.columns?.includes("TXN ID") &&
    //               !selectedValues?.columns?.includes("Description") &&
    //               !selectedValues?.columns?.includes("Capital Refund Units") &&
    //               !selectedValues?.columns?.includes("Fund Units") &&
    //               !selectedValues?.columns?.includes("NAV") &&
    //               selectedValues?.columns?.includes("Gross Amount")
    //               ? `${heading}_change${ele?.opening_balance}`
    //               : "",
    //           Sale_Load:
    //             !selectedValues?.columns?.includes("Date") &&
    //               !selectedValues?.columns?.includes("TXN ID") &&
    //               !selectedValues?.columns?.includes("Description") &&
    //               !selectedValues?.columns?.includes("Capital Refund Units") &&
    //               !selectedValues?.columns?.includes("Fund Units") &&
    //               !selectedValues?.columns?.includes("NAV") &&
    //               !selectedValues?.columns?.includes("Gross Amount") &&
    //               selectedValues?.columns?.includes("Sale Load")
    //               ? `${heading}_change${ele?.opening_balance}`
    //               : "",
    //           Redemption_Load:
    //             !selectedValues?.columns?.includes("Date") &&
    //               !selectedValues?.columns?.includes("TXN ID") &&
    //               !selectedValues?.columns?.includes("Description") &&
    //               !selectedValues?.columns?.includes("Capital Refund Units") &&
    //               !selectedValues?.columns?.includes("Fund Units") &&
    //               !selectedValues?.columns?.includes("NAV") &&
    //               !selectedValues?.columns?.includes("Gross Amount") &&
    //               !selectedValues?.columns?.includes("Sale Load") &&
    //               selectedValues?.columns?.includes("Redemption Load")
    //               ? `${heading}_change${ele?.opening_balance}`
    //               : "",
    //           CGT:
    //             !selectedValues?.columns?.includes("Date") &&
    //               !selectedValues?.columns?.includes("TXN ID") &&
    //               !selectedValues?.columns?.includes("Description") &&
    //               !selectedValues?.columns?.includes("Capital Refund Units") &&
    //               !selectedValues?.columns?.includes("Fund Units") &&
    //               !selectedValues?.columns?.includes("NAV") &&
    //               !selectedValues?.columns?.includes("Gross Amount") &&
    //               !selectedValues?.columns?.includes("Sale Load") &&
    //               !selectedValues?.columns?.includes("Redemption Load") &&
    //               selectedValues?.columns?.includes("CGT")
    //               ? `${heading}_change${ele?.opening_balance}`
    //               : "",
    //           Net_Amount:
    //             !selectedValues?.columns?.includes("Date") &&
    //               !selectedValues?.columns?.includes("TXN ID") &&
    //               !selectedValues?.columns?.includes("Description") &&
    //               !selectedValues?.columns?.includes("Capital Refund Units") &&
    //               !selectedValues?.columns?.includes("Fund Units") &&
    //               !selectedValues?.columns?.includes("NAV") &&
    //               !selectedValues?.columns?.includes("Gross Amount") &&
    //               !selectedValues?.columns?.includes("Sale Load") &&
    //               !selectedValues?.columns?.includes("Redemption Load") &&
    //               !selectedValues?.columns?.includes("CGT") &&
    //               selectedValues?.columns?.includes("Net Amount")
    //               ? `${heading}_change_${ele?.opening_balance}`
    //               : "",
    //           Closing_Units: selectedValues?.columns?.includes("Date")
    //             ? selectedValues?.balance?.includes("Opening Balance")
    //               ? `Opening Units: ${numberWithCommas(
    //                 parseFloat(ele.openingUnits).toFixed(4)
    //               )}`
    //               : ""
    //             : "",
    //         });
    //         if (ele.forPeriodTxns?.length > 0) {
    //           temp?.push(
    //             {
    //               Date:
    //                 selectedValues?.columns?.includes("Capital Refund Units") ||
    //                   selectedValues?.columns?.includes("Fund Units") ||
    //                   selectedValues?.columns?.includes("Gross Amount") ||
    //                   selectedValues?.columns?.includes("Sale Load") ||
    //                   selectedValues?.columns?.includes("Redemption Load") ||
    //                   selectedValues?.columns?.includes("CGT") ||
    //                   selectedValues?.columns?.includes("Net Amount")
    //                   ? "Total"
    //                   : "",
    //               TXN_ID: "",
    //               Description: "",
    //               Capital_Refund_Units: numberWithCommas(
    //                 parseFloat(ele.total_refundCapital).toFixed(4)
    //               ),
    //               Fund_Units: numberWithCommas(
    //                 parseFloat(ele.total_units).toFixed(4)
    //               ),
    //               NAV: "",
    //               Gross_Amount: numberWithCommas(
    //                 parseFloat(ele.total_grossAmount).toFixed(4)
    //               ),
    //               Sale_Load: numberWithCommas(
    //                 parseFloat(ele.total_saleLoad).toFixed(4)
    //               ),
    //               Redemption_Load: numberWithCommas(
    //                 parseFloat(ele.total_redemptionLoad).toFixed(4)
    //               ),
    //               CGT: numberWithCommas(parseFloat(ele.total_CGT).toFixed(4)),
    //               Net_Amount: numberWithCommas(
    //                 parseFloat(ele.total_netAmount).toFixed(4)
    //               ),
    //               Closing_Units: "",
    //             },
    //             {
    //               Date:
    //                 selectedValues?.columns?.includes("Date") &&
    //                   !selectedValues?.columns?.includes("TXN ID") &&
    //                   !selectedValues?.columns?.includes("Description") &&
    //                   !selectedValues?.columns?.includes("Capital Refund Units") &&
    //                   !selectedValues?.columns?.includes("Fund Units") &&
    //                   !selectedValues?.columns?.includes("NAV") &&
    //                   !selectedValues?.columns?.includes("Gross Amount") &&
    //                   !selectedValues?.columns?.includes("Sale Load") &&
    //                   !selectedValues?.columns?.includes("Redemption Load") &&
    //                   !selectedValues?.columns?.includes("CGT") &&
    //                   !selectedValues?.columns?.includes("Net Amount") &&
    //                   !selectedValues?.columns?.includes("Closing Units")
    //                   ? selectedValues?.balance?.includes("Closing Balance")
    //                     ? `Closing Units: ${numberWithCommas(
    //                       parseFloat(ele.closingUnits).toFixed(4)
    //                     )}`
    //                     : ""
    //                   : "",
    //               TXN_ID:
    //                 selectedValues?.columns?.includes("TXN ID") &&
    //                   !selectedValues?.columns?.includes("Description") &&
    //                   !selectedValues?.columns?.includes("Capital Refund Units") &&
    //                   !selectedValues?.columns?.includes("Fund Units") &&
    //                   !selectedValues?.columns?.includes("NAV") &&
    //                   !selectedValues?.columns?.includes("Gross Amount") &&
    //                   !selectedValues?.columns?.includes("Sale Load") &&
    //                   !selectedValues?.columns?.includes("Redemption Load") &&
    //                   !selectedValues?.columns?.includes("CGT") &&
    //                   !selectedValues?.columns?.includes("Net Amount") &&
    //                   !selectedValues?.columns?.includes("Closing Units")
    //                   ? selectedValues?.balance?.includes("Closing Balance")
    //                     ? `Closing Units: ${numberWithCommas(
    //                       parseFloat(ele.closingUnits).toFixed(4)
    //                     )}`
    //                     : ""
    //                   : "",
    //               Description:
    //                 selectedValues?.columns?.includes("Description") &&
    //                   !selectedValues?.columns?.includes("Capital Refund Units") &&
    //                   !selectedValues?.columns?.includes("Fund Units") &&
    //                   !selectedValues?.columns?.includes("NAV") &&
    //                   !selectedValues?.columns?.includes("Gross Amount") &&
    //                   !selectedValues?.columns?.includes("Sale Load") &&
    //                   !selectedValues?.columns?.includes("Redemption Load") &&
    //                   !selectedValues?.columns?.includes("CGT") &&
    //                   !selectedValues?.columns?.includes("Net Amount") &&
    //                   !selectedValues?.columns?.includes("Closing Units")
    //                   ? selectedValues?.balance?.includes("Closing Balance")
    //                     ? `Closing Units: ${numberWithCommas(
    //                       parseFloat(ele.closingUnits).toFixed(4)
    //                     )}`
    //                     : ""
    //                   : "",
    //               Capital_Refund_Units:
    //                 selectedValues?.columns?.includes("Capital Refund Units") &&
    //                   !selectedValues?.columns?.includes("Fund Units") &&
    //                   !selectedValues?.columns?.includes("NAV") &&
    //                   !selectedValues?.columns?.includes("Gross Amount") &&
    //                   !selectedValues?.columns?.includes("Sale Load") &&
    //                   !selectedValues?.columns?.includes("Redemption Load") &&
    //                   !selectedValues?.columns?.includes("CGT") &&
    //                   !selectedValues?.columns?.includes("Net Amount") &&
    //                   !selectedValues?.columns?.includes("Closing Units")
    //                   ? selectedValues?.balance?.includes("Closing Balance")
    //                     ? `Closing Units: ${numberWithCommas(
    //                       parseFloat(ele.closingUnits).toFixed(4)
    //                     )}`
    //                     : ""
    //                   : "",
    //               Fund_Units:
    //                 selectedValues?.columns?.includes("Fund Units") &&
    //                   !selectedValues?.columns?.includes("NAV") &&
    //                   !selectedValues?.columns?.includes("Gross Amount") &&
    //                   !selectedValues?.columns?.includes("Sale Load") &&
    //                   !selectedValues?.columns?.includes("Redemption Load") &&
    //                   !selectedValues?.columns?.includes("CGT") &&
    //                   !selectedValues?.columns?.includes("Net Amount") &&
    //                   !selectedValues?.columns?.includes("Closing Units")
    //                   ? selectedValues?.balance?.includes("Closing Balance")
    //                     ? `Closing Units: ${numberWithCommas(
    //                       parseFloat(ele.closingUnits).toFixed(4)
    //                     )}`
    //                     : ""
    //                   : "",
    //               NAV:
    //                 selectedValues?.columns?.includes("NAV") &&
    //                   !selectedValues?.columns?.includes("Gross Amount") &&
    //                   !selectedValues?.columns?.includes("Sale Load") &&
    //                   !selectedValues?.columns?.includes("Redemption Load") &&
    //                   !selectedValues?.columns?.includes("CGT") &&
    //                   !selectedValues?.columns?.includes("Net Amount") &&
    //                   !selectedValues?.columns?.includes("Closing Units")
    //                   ? selectedValues?.balance?.includes("Closing Balance")
    //                     ? `Closing Units: ${numberWithCommas(
    //                       parseFloat(ele.closingUnits).toFixed(4)
    //                     )}`
    //                     : ""
    //                   : "",
    //               Gross_Amount:
    //                 selectedValues?.columns?.includes("Gross Amount") &&
    //                   !selectedValues?.columns?.includes("Sale Load") &&
    //                   !selectedValues?.columns?.includes("Redemption Load") &&
    //                   !selectedValues?.columns?.includes("CGT") &&
    //                   !selectedValues?.columns?.includes("Net Amount") &&
    //                   !selectedValues?.columns?.includes("Closing Units")
    //                   ? selectedValues?.balance?.includes("Closing Balance")
    //                     ? `Closing Units: ${numberWithCommas(
    //                       parseFloat(ele.closingUnits).toFixed(4)
    //                     )}`
    //                     : ""
    //                   : "",
    //               Sale_Load:
    //                 selectedValues?.columns?.includes("Sale Load") &&
    //                   !selectedValues?.columns?.includes("Redemption Load") &&
    //                   !selectedValues?.columns?.includes("CGT") &&
    //                   !selectedValues?.columns?.includes("Net Amount") &&
    //                   !selectedValues?.columns?.includes("Closing Units")
    //                   ? selectedValues?.balance?.includes("Closing Balance")
    //                     ? `Closing Units: ${numberWithCommas(
    //                       parseFloat(ele.closingUnits).toFixed(4)
    //                     )}`
    //                     : ""
    //                   : "",
    //               Redemption_Load:
    //                 selectedValues?.columns?.includes("Redemption Load") &&
    //                   !selectedValues?.columns?.includes("CGT") &&
    //                   !selectedValues?.columns?.includes("Net Amount") &&
    //                   !selectedValues?.columns?.includes("Closing Units")
    //                   ? selectedValues?.balance?.includes("Closing Balance")
    //                     ? `Closing Units: ${numberWithCommas(
    //                       parseFloat(ele.closingUnits).toFixed(4)
    //                     )}`
    //                     : ""
    //                   : "",
    //               CGT:
    //                 selectedValues?.columns?.includes("CGT") &&
    //                   !selectedValues?.columns?.includes("Net Amount") &&
    //                   !selectedValues?.columns?.includes("Closing Units")
    //                   ? selectedValues?.balance?.includes("Closing Balance")
    //                     ? `Closing Units: ${numberWithCommas(
    //                       parseFloat(ele.closingUnits).toFixed(4)
    //                     )}`
    //                     : ""
    //                   : "",
    //               Net_Amount:
    //                 selectedValues?.columns?.includes("Net Amount") &&
    //                   !selectedValues?.columns?.includes("Closing Units")
    //                   ? selectedValues?.balance?.includes("Closing Balance")
    //                     ? `Closing Units: ${numberWithCommas(
    //                       parseFloat(ele.closingUnits).toFixed(4)
    //                     )}`
    //                     : ""
    //                   : "",
    //               Closing_Units: selectedValues?.columns?.includes("Closing Units")
    //                 ? selectedValues?.balance?.includes("Closing Balance")
    //                   ? `Closing Units: ${numberWithCommas(
    //                     parseFloat(ele.closingUnits).toFixed(4)
    //                   )}`
    //                   : ""
    //                 : "",
    //             },

    //           );
    //         }
    //         else {
    //           temp?.push(
    //             {
    //               Date: "No Recent Transactions!",
    //               TXN_ID: "",
    //               Description: "",
    //               Capital_Refund_Units: "",
    //               Fund_Units: "",
    //               NAV: "",
    //               Gross_Amount: "",
    //               Sale_Load: "",
    //               Redemption_Load: "",
    //               CGT: "",
    //               Net_Amount: "",
    //               Closing_Units: "",
    //             },
    //             {
    //               Date:
    //                 selectedValues?.columns?.includes("Date") &&
    //                   !selectedValues?.columns?.includes("TXN ID") &&
    //                   !selectedValues?.columns?.includes("Description") &&
    //                   !selectedValues?.columns?.includes("Capital Refund Units") &&
    //                   !selectedValues?.columns?.includes("Fund Units") &&
    //                   !selectedValues?.columns?.includes("NAV") &&
    //                   !selectedValues?.columns?.includes("Gross Amount") &&
    //                   !selectedValues?.columns?.includes("Sale Load") &&
    //                   !selectedValues?.columns?.includes("Redemption Load") &&
    //                   !selectedValues?.columns?.includes("CGT") &&
    //                   !selectedValues?.columns?.includes("Net Amount") &&
    //                   !selectedValues?.columns?.includes("Closing Units")
    //                   ? selectedValues?.balance?.includes("Closing Balance")
    //                     ? `Closing Units: ${numberWithCommas(
    //                       parseFloat(ele.closingUnits).toFixed(4)
    //                     )}`
    //                     : ""
    //                   : "",
    //               TXN_ID:
    //                 selectedValues?.columns?.includes("TXN ID") &&
    //                   !selectedValues?.columns?.includes("Description") &&
    //                   !selectedValues?.columns?.includes("Capital Refund Units") &&
    //                   !selectedValues?.columns?.includes("Fund Units") &&
    //                   !selectedValues?.columns?.includes("NAV") &&
    //                   !selectedValues?.columns?.includes("Gross Amount") &&
    //                   !selectedValues?.columns?.includes("Sale Load") &&
    //                   !selectedValues?.columns?.includes("Redemption Load") &&
    //                   !selectedValues?.columns?.includes("CGT") &&
    //                   !selectedValues?.columns?.includes("Net Amount") &&
    //                   !selectedValues?.columns?.includes("Closing Units")
    //                   ? selectedValues?.balance?.includes("Closing Balance")
    //                     ? `Closing Units: ${numberWithCommas(
    //                       parseFloat(ele.closingUnits).toFixed(4)
    //                     )}`
    //                     : ""
    //                   : "",
    //               Description:
    //                 selectedValues?.columns?.includes("Description") &&
    //                   !selectedValues?.columns?.includes("Capital Refund Units") &&
    //                   !selectedValues?.columns?.includes("Fund Units") &&
    //                   !selectedValues?.columns?.includes("NAV") &&
    //                   !selectedValues?.columns?.includes("Gross Amount") &&
    //                   !selectedValues?.columns?.includes("Sale Load") &&
    //                   !selectedValues?.columns?.includes("Redemption Load") &&
    //                   !selectedValues?.columns?.includes("CGT") &&
    //                   !selectedValues?.columns?.includes("Net Amount") &&
    //                   !selectedValues?.columns?.includes("Closing Units")
    //                   ? selectedValues?.balance?.includes("Closing Balance")
    //                     ? `Closing Units: ${numberWithCommas(
    //                       parseFloat(ele.closingUnits).toFixed(4)
    //                     )}`
    //                     : ""
    //                   : "",
    //               Capital_Refund_Units:
    //                 selectedValues?.columns?.includes("Capital Refund Units") &&
    //                   !selectedValues?.columns?.includes("Fund Units") &&
    //                   !selectedValues?.columns?.includes("NAV") &&
    //                   !selectedValues?.columns?.includes("Gross Amount") &&
    //                   !selectedValues?.columns?.includes("Sale Load") &&
    //                   !selectedValues?.columns?.includes("Redemption Load") &&
    //                   !selectedValues?.columns?.includes("CGT") &&
    //                   !selectedValues?.columns?.includes("Net Amount") &&
    //                   !selectedValues?.columns?.includes("Closing Units")
    //                   ? selectedValues?.balance?.includes("Closing Balance")
    //                     ? `Closing Units: ${numberWithCommas(
    //                       parseFloat(ele.closingUnits).toFixed(4)
    //                     )}`
    //                     : ""
    //                   : "",
    //               Fund_Units:
    //                 selectedValues?.columns?.includes("Fund Units") &&
    //                   !selectedValues?.columns?.includes("NAV") &&
    //                   !selectedValues?.columns?.includes("Gross Amount") &&
    //                   !selectedValues?.columns?.includes("Sale Load") &&
    //                   !selectedValues?.columns?.includes("Redemption Load") &&
    //                   !selectedValues?.columns?.includes("CGT") &&
    //                   !selectedValues?.columns?.includes("Net Amount") &&
    //                   !selectedValues?.columns?.includes("Closing Units")
    //                   ? selectedValues?.balance?.includes("Closing Balance")
    //                     ? `Closing Units: ${numberWithCommas(
    //                       parseFloat(ele.closingUnits).toFixed(4)
    //                     )}`
    //                     : ""
    //                   : "",
    //               NAV:
    //                 selectedValues?.columns?.includes("NAV") &&
    //                   !selectedValues?.columns?.includes("Gross Amount") &&
    //                   !selectedValues?.columns?.includes("Sale Load") &&
    //                   !selectedValues?.columns?.includes("Redemption Load") &&
    //                   !selectedValues?.columns?.includes("CGT") &&
    //                   !selectedValues?.columns?.includes("Net Amount") &&
    //                   !selectedValues?.columns?.includes("Closing Units")
    //                   ? selectedValues?.balance?.includes("Closing Balance")
    //                     ? `Closing Units: ${numberWithCommas(
    //                       parseFloat(ele.closingUnits).toFixed(4)
    //                     )}`
    //                     : ""
    //                   : "",
    //               Gross_Amount:
    //                 selectedValues?.columns?.includes("Gross Amount") &&
    //                   !selectedValues?.columns?.includes("Sale Load") &&
    //                   !selectedValues?.columns?.includes("Redemption Load") &&
    //                   !selectedValues?.columns?.includes("CGT") &&
    //                   !selectedValues?.columns?.includes("Net Amount") &&
    //                   !selectedValues?.columns?.includes("Closing Units")
    //                   ? selectedValues?.balance?.includes("Closing Balance")
    //                     ? `Closing Units: ${numberWithCommas(
    //                       parseFloat(ele.closingUnits).toFixed(4)
    //                     )}`
    //                     : ""
    //                   : "",
    //               Sale_Load:
    //                 selectedValues?.columns?.includes("Sale Load") &&
    //                   !selectedValues?.columns?.includes("Redemption Load") &&
    //                   !selectedValues?.columns?.includes("CGT") &&
    //                   !selectedValues?.columns?.includes("Net Amount") &&
    //                   !selectedValues?.columns?.includes("Closing Units")
    //                   ? selectedValues?.balance?.includes("Closing Balance")
    //                     ? `Closing Units: ${numberWithCommas(
    //                       parseFloat(ele.closingUnits).toFixed(4)
    //                     )}`
    //                     : ""
    //                   : "",
    //               Redemption_Load:
    //                 selectedValues?.columns?.includes("Redemption Load") &&
    //                   !selectedValues?.columns?.includes("CGT") &&
    //                   !selectedValues?.columns?.includes("Net Amount") &&
    //                   !selectedValues?.columns?.includes("Closing Units")
    //                   ? selectedValues?.balance?.includes("Closing Balance")
    //                     ? `Closing Units: ${numberWithCommas(
    //                       parseFloat(ele.closingUnits).toFixed(4)
    //                     )}`
    //                     : ""
    //                   : "",
    //               CGT:
    //                 selectedValues?.columns?.includes("CGT") &&
    //                   !selectedValues?.columns?.includes("Net Amount") &&
    //                   !selectedValues?.columns?.includes("Closing Units")
    //                   ? selectedValues?.balance?.includes("Closing Balance")
    //                     ? `Closing Units: ${numberWithCommas(
    //                       parseFloat(ele.closingUnits).toFixed(4)
    //                     )}`
    //                     : ""
    //                   : "",
    //               Net_Amount:
    //                 selectedValues?.columns?.includes("Net Amount") &&
    //                   !selectedValues?.columns?.includes("Closing Units")
    //                   ? selectedValues?.balance?.includes("Closing Balance")
    //                     ? `Closing Units: ${numberWithCommas(
    //                       parseFloat(ele.closingUnits).toFixed(4)
    //                     )}`
    //                     : ""
    //                   : "",
    //               Closing_Units: selectedValues?.columns?.includes("Closing Units")
    //                 ? selectedValues?.balance?.includes("Closing Balance")
    //                   ? `Closing Units: ${numberWithCommas(
    //                     parseFloat(ele.closingUnits).toFixed(4)
    //                   )}`
    //                   : ""
    //                 : "",
    //             }
    //           );
    //         }
    //         return temp;
    //       })
    //       ?.flat(1);

    //     const reorderColumns = (columns, order) => {
    //       return order.filter((column) => columns.includes(column));
    //     };

    //     const reorderedColumns = reorderColumns(
    //       selectedValues?.columns,
    //       fixedOrder
    //     );

    //     const ArrayData =
    //       selectedValues?.columns?.length > 0 &&
    //       dataSequence?.map((entry) => {
    //         const result = {};
    //         reorderedColumns.forEach((column) => {
    //           if (column === "Date") {
    //             result[column] = entry?.Date;
    //           } else if (column === "TXN ID") {
    //             result[column] = entry?.TXN_ID;
    //           } else if (column === "Description") {
    //             result[column] = entry?.Description;
    //           } else if (column === "Capital Refund Units") {
    //             result[column] = numberWithCommas(entry?.Capital_Refund_Units);
    //           } else if (column === "Fund Units") {
    //             result[column] = numberWithCommas(entry?.Fund_Units);
    //           } else if (column === "NAV") {
    //             result[column] = numberWithCommas(entry?.NAV);
    //           } else if (column === "Gross Amount") {
    //             result[column] = numberWithCommas(entry?.Gross_Amount);
    //           } else if (column === "Sale Load") {
    //             result[column] = numberWithCommas(entry?.Sale_Load);
    //           } else if (column === "Redemption Load") {
    //             result[column] = numberWithCommas(entry?.Redemption_Load);
    //           } else if (column === "CGT") {
    //             result[column] = numberWithCommas(entry?.CGT);
    //           } else if (column === "Net Amount") {
    //             result[column] = numberWithCommas(entry?.Net_Amount);
    //           } else if (column === "Closing Units") {
    //             result[column] = numberWithCommas(entry?.Closing_Units);
    //           }
    //         });
    //         return result;
    //       });

    //     const finalData = ArrayData?.map((obj) => {
    //       const hasChange = Object.values(obj).some((value) =>
    //         String(value).includes("_change")
    //       );

    //       if (hasChange) {
    //         const lastKey = Object.keys(obj)[Object.keys(obj).length - 1];

    //         const updatedObj = Object.keys(obj).reduce((acc, key) => {
    //           const value = obj[key];

    //           if (typeof value === "string" && value.includes("_change")) {
    //             const parts = value.split("_");
    //             acc[key] = parts[0];
    //           } else {
    //             acc[key] = value;
    //           }

    //           return acc;
    //         }, {});

    //         const openingBalanceValues = Object.values(obj)
    //           .map((item: any) => {
    //             const parts = item.split("_");
    //             return parts.length > 2 ? parts[2] : null;
    //           })
    //           .filter(Boolean);

    //         const openingBalance = openingBalanceValues[0];

    //         return {
    //           ...updatedObj,
    //           [lastKey]: selectedValues?.balance?.includes("Opening Balance")
    //             ? `Opening Units: ${numberWithCommas(
    //               parseFloat(openingBalance || 0).toFixed(4)
    //             )}`
    //             : "",
    //         };
    //       }

    //       return obj;
    //     });

    //     if (finalData.length > 0) {
    //       const keys = Object.keys(finalData[0]);
    //       const lastKey = keys[keys.length - 1];

    //       const newObj1 = keys.reduce((acc, key) => {
    //         acc[key] = key === lastKey ? nav : "";
    //         return acc;
    //       }, {});
    //       finalData.push(newObj1);

    //       const newObj2 = keys.reduce((acc, key) => {
    //         acc[key] = key === lastKey ? balance : "";
    //         return acc;
    //       }, {});
    //       finalData.push(newObj2);
    //     }

    //     generateExcel(
    //       "Unit Holder Statement Report",
    //       "Unit Holder Statement Report",
    //       "File",
    //       "File",
    //       "DCCL",
    //       headings,
    //       reorderedColumns,
    //       finalData,
    //       [],
    //       []
    //     );
    //   };

    const customStyles = {
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        option: (styles, { isFocused, isSelected }) => ({
            ...styles,
            background: isFocused
                ? "hsla(291, 64%, 42%, 0.5)"
                : isSelected
                    ? "hsla(291, 64%, 42%, 1)"
                    : undefined,
            zIndex: 1,
        }),
        menuList: (styles) => ({
            ...styles,
            background: theme == "dark" ? "#3b3b3b" : "#ffffff",
            color: theme == "dark" ? "white" : "",
        }),
        menu: (base) => ({
            ...base,
            zIndex: 100,
        }),
        control: (base, state) => ({
            ...base,
            background: theme == "dark" ? "#25273a" : "#f2f2f2",
            borderRadius: "0.4285rem",
            borderColor: state.isFocused
                ? "#1d8cf8"
                : theme !== "light"
                    ? "#2b3553"
                    : "",
            boxShadow: state.isFocused ? null : null,
            "&:hover": {
                borderColor: state.isFocused ? "" : "#ba54f5",
            },
            '& .react-select__input input[type="color"]': {
                color: theme === "dark" ? "red" : "black",
            },
        }),
        singleValue: (provided) => ({
            ...provided,
            color: theme == "dark" ? "white" : "black",
        }),
        input: (base) => ({
            ...base,
            color: theme == "dark" ? "white" : "black",
        }),
    };

    return (
        <>
            <ToastContainer />

            <div className="content">
                <Row>
                    <Col md="12">
                        <Container fluid>
                            {
                                apiLoading ? (
                                    <Row>
                                        <Col>
                                            <div className="d-flex flex-column align-items-center justify-content-center my-5">
                                                <i
                                                    className="fa fa-spinner fa-spin fa-3x"
                                                    aria-hidden="true"
                                                ></i>
                                                <text>Loading Initial API data for Dropdown</text>
                                            </div>
                                        </Col>
                                    </Row>
                                ) : (
                                    <>
                                        <Row>
                                            <Col>
                                                <div className="card mb-3">
                                                    <div className="card-header d-flex align-items-center justify-content-between">
                                                        <h4 className="card-title">Dividend Statement</h4>
                                                    </div>
                                                    <div className="card-body">
                                                        <Row className="align-items-center">
                                                            <Col
                                                                xl={3}
                                                                lg={3}
                                                                md={4}
                                                                sm={12}
                                                                xs={12}
                                                                className="form-group col-md-4"
                                                                data-tip="Select Announcement"
                                                            >
                                                                Announcement*
                                                                <ReactTooltip
                                                                    textColor="white"
                                                                    backgroundColor="black"
                                                                    effect="float"
                                                                />
                                                                {announcementDataLoading ? (
                                                                    <div className="form-control w-100">
                                                                        <i className="fa fa-spinner fa-spin fa-1x"></i>
                                                                    </div>
                                                                ) : (
                                                                    <Select
                                                                        // isDisabled={!selectedFund}
                                                                        value={selectedAnnouncementVal}
                                                                        label={
                                                                            selectedFund
                                                                                ? "No Announcement Found"
                                                                                : "Select Announcement"
                                                                        }
                                                                        onChange={(e: any) => {
                                                                            setDividendData([]);
                                                                            setSelectedAnnoucement(e?.value);
                                                                            setApiCallDone(false);
                                                                            setDividendData([])
                                                                        }}
                                                                        menuPortalTarget={document.body}
                                                                        menuShouldBlockScroll={true}
                                                                        isClearable={true}
                                                                        isSearchable={true}
                                                                        name="color"
                                                                        options={renderAnnoucementDropdown()}
                                                                        styles={customStyles}
                                                                    />
                                                                )}
                                                            </Col>
                                                            <Col
                                                                xl={3}
                                                                lg={3}
                                                                md={4}
                                                                sm={12}
                                                                xs={12}
                                                                className="form-group col-md-4"
                                                                data-tip="Select Announcement"
                                                            >
                                                                Select Folio*
                                                                <ReactTooltip
                                                                    textColor="white"
                                                                    backgroundColor="black"
                                                                    effect="float"
                                                                />
                                                                {announcementDataLoading ? (
                                                                    <div className="form-control w-100">
                                                                        <i className="fa fa-spinner fa-spin fa-1x"></i>
                                                                    </div>
                                                                ) : (
                                                                    <Select
                                                                        isDisabled={!selectedAnnoucement}
                                                                        value={selectedFolioVal}
                                                                        label={"Select Folio"}
                                                                        onChange={(e: any) => {
                                                                            setFolio(e?.value);
                                                                            setDividendData([])
                                                                        }}
                                                                        menuPortalTarget={document.body}
                                                                        menuShouldBlockScroll={true}
                                                                        isClearable={true}
                                                                        isSearchable={true}
                                                                        name="color"
                                                                        options={renderAllFoliosDropdown()}
                                                                        styles={customStyles}
                                                                    />
                                                                )}
                                                            </Col>
                                                            <Col md="2">
                                                                <div
                                                                    style={{
                                                                        marginTop: "4px",
                                                                    }}
                                                                >
                                                                    <button
                                                                        className="btn btn-primary py-2 mt-3"
                                                                        onClick={() => {
                                                                            searchData();
                                                                        }}
                                                                        disabled={
                                                                            !selectedAnnoucement ||
                                                                            !folio ||
                                                                            btnLoading
                                                                        }
                                                                    >
                                                                        {btnLoading ? "Loading..." :
                                                                            "Search"}
                                                                    </button>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>

                                                </div>
                                                <div className="card mt-3">
                                                    <div className="card-body">
                                                        <Row>
                                                            <ReportTemplates
                                                                ColumnArr={ColumnArr}
                                                                selectedValues={selectedValues}
                                                                setSelectedValues={setSelectedValues}
                                                                pdfExportComponent={pdfExportComponent}
                                                                setFontSizeVal={setFontSizeVal}
                                                                fontSizeVal={fontSizeVal}
                                                                setPaperSizeVal={setPaperSizeVal}
                                                                paperSizeVal={paperSizeVal}
                                                                setLayoutVal={setLayoutVal}
                                                                layoutVal={layoutVal}
                                                                setScalePDF={setScalePDF}
                                                                scalePDF={scalePDF}
                                                                setMarginPDF={setMarginPDF}
                                                                marginPDF={marginPDF}
                                                                setScreenSizePerPdf={setScreenSizePerPdf}
                                                                screenSizePerPdf={screenSizePerPdf}
                                                                setDimensionOfPages={setDimensionOfPages}
                                                                contentRef={contentRef}
                                                                fileName={"Process-Entitlement-Statement-" + date + ".pdf"}
                                                                printExcel={handleDownloadSampleFile}
                                                                printTXT={handleTXT}
                                                                printpdf={handleGeneratePdf}
                                                            />
                                                        </Row>
                                                        <div
                                                            id="printDiv"
                                                            className="p-4"
                                                            style={{
                                                                color: "black",
                                                                minWidth: "200px",
                                                                overflowX: "auto",
                                                                width: "auto",
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    width: `${dimensionOfPages?.find(
                                                                        (item) => item?.key == paperSizeVal
                                                                    )?.dimensions[layoutVal == "Portrait" ? 0 : 1]
                                                                        }`,
                                                                    height: "auto",
                                                                    margin: "0 auto",
                                                                    backgroundColor: "white",
                                                                }}
                                                                className="border"
                                                            >
                                                                <div
                                                                    style={{
                                                                        margin: "0.25in"
                                                                    }}
                                                                    ref={contentRef}>
                                                                    {
                                                                        dividendData?.length > 0 ?
                                                                            <>
                                                                                <ReportHeader title="Dividend Statement" />
                                                                                <Row>
                                                                                    <Col>
                                                                                        <DividendCard
                                                                                            data={dividendSummaryData}
                                                                                            unitholderDetails={allFolios?.find(
                                                                                                (item) => item?.folio_no?.replace("UNITHOLDER_", "") === folio
                                                                                            )}
                                                                                            report={true}
                                                                                        />
                                                                                    </Col>
                                                                                </Row>

                                                                                {apiCallDone && (
                                                                                    <Row>
                                                                                        <Col>
                                                                                            <DividendTable
                                                                                                dividendData={dividendData}
                                                                                                report={true}
                                                                                                columns={selectedValues?.columns}
                                                                                            />
                                                                                            <div className="d-flex justify-content-center">
                                                                                                {hasNextPage && (
                                                                                                    <button
                                                                                                        className="btn pointer mt-3 mx-2"
                                                                                                        onClick={() => handleShowMore()}
                                                                                                    >
                                                                                                        {
                                                                                                            btnLoading ? (
                                                                                                                <span>
                                                                                                                    Loading...{" "}
                                                                                                                    <i
                                                                                                                        className="fa fa-spinner fa-spin  "
                                                                                                                        aria-hidden="true"
                                                                                                                    ></i>
                                                                                                                </span>
                                                                                                            ) : (
                                                                                                                "Show More"
                                                                                                            )}
                                                                                                    </button>
                                                                                                )}
                                                                                            </div>
                                                                                        </Col>
                                                                                    </Row>
                                                                                )}
                                                                            </> :
                                                                            <div className="table-empty">
                                                                                <BsTable className="icon" />
                                                                                <p className="text-center empty-text text-primary">
                                                                                    No record found
                                                                                </p>
                                                                            </div>
                                                                    }

                                                                </div>

                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>

                                            </Col>
                                        </Row>
                                    </>
                                )
                            }

                        </Container>
                    </Col>
                </Row>
            </div>
        </>
    )
}

export default ProcessEntitlementsReport